import graphQl from '../../../../services/graphQl';
import { Commit, ActionTree, Dispatch } from 'vuex';
import { State } from './trace.store';
import { AxiosResponse } from 'axios';
import * as types from '../mutation-types';

// actions
const actions: ActionTree<State, any> = {
  GET_ENDPOINTS(context: { commit: Commit }, params: any): Promise<void> {
    if (!params.serviceId) {
      return new Promise((resolve) => resolve());
    }
    return graphQl
      .query('queryRangeEndpoints')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit(types.SET_ENDPOINTS, res.data.data.getEndpoints);
      })
      .catch((error) => console.log('error', error));
  },
  GET_INSTANCES(context: { commit: Commit }, params: any): Promise<void> {
    if (!params.serviceId) {
      return new Promise((resolve) => resolve());
    }
    return graphQl
      .query('queryServiceInstance')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit(types.SET_INSTANCES, res.data.data.instanceId);
      })
      .catch((error) => console.log('error', error));
  },
  SET_TRACE_FORM(
    context: { commit: Commit; dispatch: Dispatch },
    params: any,
  ): void {
    context.commit(types.SET_TRACE_FORM, params);
  },
  GET_TRACELIST(context: { state: State; commit: Commit }): Promise<void> {
    context.commit(types.SET_TRACELIST, []);
    if (
      (!context.state.traceForm.serviceId &&
        !context.state.traceForm.traceId) ||
      context.state.currentTraceId
    ) {
      return new Promise((resolve) => resolve());
    }
    return graphQl
      .query('queryTraces')
      .params({ condition: context.state.traceForm })
      .then((res: AxiosResponse) => {
        context.commit(types.SET_TRACELIST, res.data.data.data.traces);
        context.commit(types.SET_TRACELIST_TOTAL, res.data.data.data.total);
      });
  },
  GET_EMPTYTRACELIST(context: { state: State; commit: Commit }): Promise<void> {
    context.commit(types.SET_TRACELIST, []);
    return new Promise((resolve) => {
      context.commit(types.SET_TRACELIST, []);
      context.commit(types.SET_TRACELIST_TOTAL, 0);
    });
  },
  GET_TRACE_SPANS(context: { commit: Commit }, params: any): Promise<void> {
    context.commit(types.SET_TRACE_SPANS, []);
    return graphQl
      .query('queryTrace')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit(
          types.SET_TRACE_SHOW_METHOD,
          res.data?.data?.trace?.toShowMethod,
        );
        context.commit(types.SET_TRACE_SPANS, {
          ...res.data?.data?.trace,
          spans: [],
        });

        return res?.data?.data?.trace;
      })
      .catch((error) => console.log('error', error));
  },
  SET_SELECTED_TRACE_LOADING(context: { commit: Commit }, params: any) {
    context.commit(types.SET_SELECTED_TRACE_LOADING, params);
  },
  async GET_LOG_TRACELIST(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('logQueryTraces')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.data;
        } else return [];
      });
  },
  async TRACE_DETAIL_EXIST(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryTraceDetailExist')
      .params(params)
      .then((res: AxiosResponse) => {
        return res?.data?.data?.tracesExists ?? [];
      });
  },
};

export default actions;
